<script lang="ts">
	import { onMount } from 'svelte';
	import mortgage from './questions/pt/mortgage.json';
	import credit from './questions/pt/credit.json';
	import consolidated from './questions/pt/consolidated.json';
	import insurance from './questions/pt/insurance.json';
	import mortgageEN from './questions/en/mortgage.json';
	import creditEN from './questions/en/credit.json';
	import consolidatedEN from './questions/en/consolidated.json';
	import insuranceEN from './questions/en/insurance.json';
	import lpMortgageEN from './questions/en/lpMortgage.json';
	import mortgageFR from './questions/fr/mortgage.json';
	import creditFR from './questions/fr/credit.json';
	import consolidatedFR from './questions/fr/consolidated.json';
	import insuranceFR from './questions/fr/insurance.json';
	import __ from '$lib/stores/TranslationStore';
	import Question from './Question.svelte';
	import { page } from '$app/stores';

	export let category: string;
	export let showHeader: boolean = true;
	export let showCategories: boolean = false;
	const language = $page.data.language;

	let FAQs = {
		pt: {
			mortgage: mortgage,
			credit: credit,
			consolidated: consolidated,
			insurance: insurance
		},
		en: {
			mortgage: mortgageEN,
			credit: creditEN,
			consolidated: consolidatedEN,
			insurance: insuranceEN,
			lpMortgage: lpMortgageEN
		},
		fr: {
			mortgage: mortgageFR,
			credit: creditFR,
			consolidated: consolidatedFR,
			insurance: insuranceFR
		}
	};

	const getQuestionsByCategory = () => {
		switch (category) {
			case 'Crédito habitação':
				return FAQs[language]['mortgage'];
			case 'Crédito consolidado':
				return FAQs[language]['consolidated'];
			case 'Crédito pessoal':
				return FAQs[language]['credit'];
			case 'Seguros':
				return FAQs[language]['insurance'];
			case 'LP - Mortgage':
				return FAQs.en.lpMortgage;
			default:
				return [];
		}
	};

	const faqData = getQuestionsByCategory()?.map((question) => ({
		'@type': 'Question',
		name: question.q,
		acceptedAnswer: {
			'@type': 'Answer',
			text: question.a
		}
	}));

	const faqJson = {
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		mainEntity: faqData
	};

	// The FAQPage's JSON-LD is now in the body since sveltekit has a bug with duplicate head tags: https://github.com/oekazuma/svelte-meta-tags/issues/702
</script>

{@html `<script type="application/ld+json">${JSON.stringify(faqJson, null, 2)}</script>`}
<div class="faq mx-auto lg:py-16 {!showCategories ? 'container' : ''}">
	{#if showHeader}
		<slot name="header">
			<div class="mt-14 flex flex-col justify-between gap-4 lg:mb-14 lg:mt-0 lg:flex-row">
				<h3 class="text-3xl text-dark lg:text-5xl">{$__('Perguntas frequentes')}</h3>
			</div>
		</slot>
	{/if}

	<div>
		{#each getQuestionsByCategory() as question, key}
			<Question open={key == 0} question={$__(question.q)} answer={$__(question.a)} />
		{/each}
	</div>
</div>
